<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <p
                        style="margin-top:2.5svh; margin-left: 2svw; margin-right: 2svw; font-family: Lato; color: #3F616C; text-align: center; font-size: 16px; font-weight: 500;">
                        {{ withFoam }}
                    </p>
                    <div v-if="properPreparation == true">
                        <img src="./../assets/images/ejemplo_burbujas_1.png"
                            style="margin-top: 5svh; margin-left: 2svw; margin-right: 2svw; border-radius: 9px;" />
                    </div>
                    <div v-else>
                        <img src="./../assets/images/Sucio_sin_burbujas_1.png"
                            style="margin-top: 5svh; margin-left: 2svw; margin-right: 2svw; border-radius: 9px;" />
                    </div>
                </v-card>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh)); width: calc(100svw - 2svw - 2svw); margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; align-items: center; flex-flow: row">
                    <v-btn elevation="12" v-on:click="click(true);"
                        style="margin-left: auto; margin-right: auto; width: 208px; height: 69px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                        <b>Cerrar ejemplo</b>
                    </v-btn>
                </v-card>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>

import CardNav from './CardNav.vue';
import { nextScreenWithParams } from '../router/utils.js';

export default {
    name: 'Deposition',
    components: {
        CardNav
    },
    data() {
        return {
            proper: null,
            foam: ""
        }
    },
    computed: {
        properPreparation: {
            get: function () {
                return this.proper;
            },
            set: function (newValue) {
                this.proper = newValue;
            }
        },
        withFoam: {
            get: function () {
                return this.foam;
            },
            set: function (newValue) {
                this.foam = newValue;
            }
        }
    },
    methods: {
        click() {
            nextScreenWithParams(this.$router, 'ConfigTreatment', false);
        }
    },
    mounted() {
        this.properPreparation = this.$route.params.generic;
        (this.properPreparation) ? (this.withFoam = "Deposición con espuma") : (this.withFoam = "Deposición sin espuma");
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Deposition.vue